import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/landing";
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-291" data-mp="3mfhfg2d2xrgo">
      <div className="mx-auto max-w-5xl" data-id="element-292" data-mp="3r7sg57fn9haa">
        <SectionHeading eyebrow="What colleagues say" title="Professionals who review cases with a system" data-id="element-293" data-mp="3r8ttjik4ufv6" />
        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-294" data-mp="3agab2ha8jk">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl border border-navy/10 bg-cream p-6 sm:p-7" data-id="element-295" data-mp="44w3ap8q837h">
              <div className="flex items-center gap-1 text-gold" aria-label="5 out of 5 stars" data-id="element-296" data-mp="9031xin52hpj">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold" aria-hidden="true" data-id="element-297" data-mp="2aukejf1s63h0" data-mpi={i} />)}
              </div>
              <blockquote className="relative mt-4 flex-1" data-id="element-298" data-mp="2fsluvs7tnoos">
                <QuoteIcon className="absolute -left-1 -top-1 h-8 w-8 text-gold/25" aria-hidden="true" data-id="element-299" data-mp="1slkr9f00hcj1" />
                <p className="relative text-[17px] leading-relaxed text-ink/85" data-id="element-300" data-mp="1nsrk6kh2ls3s">"{t.quote}"</p>
              </blockquote>
              <div className="mt-6 flex items-center gap-4 border-t border-navy/10 pt-5" data-id="element-301" data-mp="1iv9dz1uftqzh">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-302" data-mp="1eupehrme6ba6" />
                <div data-id="element-303" data-mp="26kaocumtzc7e">
                  <p className="font-bold text-navy" data-id="element-304" data-mp="26jskpcxu9vpg">{t.name}</p>
                  <p className="text-sm text-navy/65" data-id="element-305" data-mp="26ihfr9snqhwr">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
        <div className="mt-12" data-id="element-306" data-mp="1xlyo00w5x01r">
          <CtaButton label="I want results like theirs" data-id="element-307" data-mp="r438e5vy712t" />
        </div>
      </div>
    </section>;
}